/**
 * The top of the Co-Living rooms page (Co-Living redesign, Slice 2).
 *
 * Replaces a sticky 14px `<span>` that read as a toolbar label rather than a
 * page title. The page now opens the way the other redesigned admin surfaces
 * do: a quiet breadcrumb, a real `<h1>`, one line of explanation.
 *
 * "Immobilien" is NOT a link. It is a sidebar group heading
 * (AdminSidebar.js:114-125 — `title: "Immobilien"` with `items` beneath it),
 * not a route; there is no `/admin/immobilien` to send anyone to, and
 * inventing one would be a breadcrumb that 404s.
 *
 * `actions` is an empty slot on purpose. The target design shows "Exportieren"
 * and "Zimmer hinzufügen" up here, and neither has working behaviour on this
 * page yet — a disabled placeholder would be a promise the page cannot keep.
 * The slot exists so they can arrive later without moving anything else.
 */
import React from "react";

export default function CoLivingPageHeader({ actions = null }) {
  return (
    <header>
      <nav aria-label="Breadcrumb" className="text-[11px] text-muted-foreground">
        <span>Immobilien</span>
        <span className="mx-1.5" aria-hidden="true">
          /
        </span>
        <span aria-current="page" className="text-foreground">
          Co-Living-Zimmer
        </span>
      </nav>

      <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="m-0 text-[22px] font-semibold leading-tight tracking-[-0.01em] text-foreground">
            Co-Living-Zimmer
          </h1>
          <p className="m-0 mt-1.5 max-w-2xl text-[12.5px] leading-snug text-muted-foreground">
            Übersicht über alle Co-Living-Zimmer, deren Belegung und Verfügbarkeit.
          </p>
        </div>

        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}
